import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginatedResponse, Product } from '~shared/models';
import { map } from 'rxjs/operators';
import { SearchHttpService } from '~app/modules/generic/services/search-http.service';
import {
  API_BLOOMREACH_RECOMMENDATIONS_PRODUCTS_ROUTE_V3,
  API_G_RECOMMENDATIONS_PRODUCTS_ROUTE_V3
} from '~app/modules/catalog/constants';
import { queryBuilder } from '@metromarkets/sdk';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ProductsRecommenderService {
  constructor(private searchHttpService: SearchHttpService) {
  }

  public getBloomreachRecommendedProducts(campaignId: string): Observable<Product[]> {
    const url = API_BLOOMREACH_RECOMMENDATIONS_PRODUCTS_ROUTE_V3().replace('{CAMPAIGN_ID}', campaignId);

    return this.searchHttpService.getPaginatedProducts(url, null, 'angular_bloomreach_products').pipe(
      map((paginatedResponse: PaginatedResponse<Product>) => {
        if (paginatedResponse?.items?.length === 0) {
          return [];
        }

        return paginatedResponse?.items?.map(product => Product.map(product));
      })
    );
  }

  public getGRecommendedProducts(searchTerm: string): Observable<Product[]> {
    const params = {
      'filter[top][phrase]': searchTerm
    };
    const httpParams: HttpParams = queryBuilder.toParams(params) as HttpParams;
    const url: string = API_G_RECOMMENDATIONS_PRODUCTS_ROUTE_V3();

    return this.searchHttpService.getPaginatedProducts(url, httpParams,'angular_recommended_products').pipe(
      map((paginatedResponse: PaginatedResponse<Product>) => {
        if (paginatedResponse?.items?.length === 0) {
          return [];
        }

        return paginatedResponse?.items?.map((product: Product) => Product.map(product));
      })
    );
  }
}
